export default __webpack_public_path__ + "static/media/position-status-1.1daaa585.svg";